var _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 88,
    fill: "none",
    viewBox: "0 0 60 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "jmgnu3xjma",
    width: 60,
    height: 88,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M54 0H6C2.686 0 0 2.686 0 6v76c0 3.314 2.686 6 6 6h48c3.314 0 6-2.686 6-6V6c0-3.314-2.686-6-6-6z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    mask: "url(#jmgnu3xjma)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#146EB4",
    d: "M82.214 27.218h-28.44L44.288 5.89l37.926 21.328z",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M82.214 81.741H6.362v-4.74c0-1.31 1.06-2.371 2.37-2.371h71.111c1.309 0 2.37 1.062 2.37 2.37v4.741zM76.288 74.63h-64v-4.74c0-1.31 1.06-2.37 2.37-2.37h59.26c1.308 0 2.37 1.06 2.37 2.37v4.74z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#146EB4",
    d: "M82.214 81.741H14.658v-1.185c0-1.308 1.062-2.37 2.37-2.37h65.186v3.555zM76.288 74.63H25.326v-1.185c0-1.309 1.061-2.37 2.37-2.37h48.593v3.555z",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M73.918 34.329h-59.26c-1.31 0-2.37-1.06-2.37-2.37v-4.741h64v4.74c0 1.31-1.062 2.37-2.37 2.37z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#146EB4",
    d: "M73.918 34.329H21.769v-1.185c0-1.309 1.062-2.37 2.37-2.37h52.149v1.185c0 1.31-1.06 2.37-2.37 2.37zM49.029 67.516h-4.741V41.442c0-1.308 1.062-2.37 2.37-2.37h2.37v28.444zM27.693 67.516h-4.74V41.442c0-1.308 1.061-2.37 2.37-2.37h2.37v28.444z",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93C3E3",
    d: "M44.724 5.115L82.65 26.444c.352.198.526.609.424 1-.103.39-.456.663-.86.663l-5.038-.001v3.852c0 1.8-1.46 3.26-3.258 3.26l-2.666-.001v31.412h2.666c1.797 0 3.259 1.46 3.259 3.26l-.001 3.851h2.667c1.798 0 3.26 1.463 3.26 3.26v4.74c0 .492-.398.89-.89.89H6.363c-.49 0-.889-.398-.889-.89V77c0-1.797 1.461-3.26 3.26-3.26h2.665l.001-3.851c0-1.8 1.461-3.26 3.26-3.26h2.663V35.217h-2.664c-1.798 0-3.259-1.46-3.259-3.258l-.001-3.853H6.362c-.404 0-.758-.272-.86-.662-.103-.391.072-.802.425-1L43.853 5.115c.27-.153.6-.153.87 0zm35.12 70.404H8.731c-.816 0-1.481.663-1.481 1.481v3.852h74.074V77c0-.818-.665-1.481-1.482-1.481zm-5.926-7.112h-59.26c-.816 0-1.481.664-1.481 1.482v3.852h62.222v-3.852c0-.818-.665-1.481-1.481-1.481zm-35.261-33.19H28.581v31.412h10.076V35.217zm21.336 0H49.916v31.412h10.077V35.217zm-11.854.002h-7.704v31.408h7.704V35.219zm21.336 0H61.77v31.408h7.704V35.219zm-42.671 0H19.1v31.408h7.703V35.219zm50.668 19.264c.491 0 .89.4.89.889l-.001 1.481h1.482c.49 0 .889.4.889.889 0 .492-.398.889-.89.889l-1.481-.001v1.482c0 .492-.398.89-.889.89-.49 0-.888-.398-.888-.89l-.001-1.482h-1.48c-.492 0-.89-.396-.89-.888 0-.49.398-.889.89-.889h1.48v-1.481c0-.49.399-.89.89-.89zM11.096 43.816c.49 0 .889.4.889.889l-.001 1.481h1.482c.49 0 .889.4.889.89 0 .491-.398.888-.889.888h-1.482v1.482c0 .492-.398.889-.888.889-.491 0-.89-.398-.89-.89v-1.481h-1.48c-.491 0-.89-.397-.89-.889 0-.49.399-.889.89-.889h1.48v-1.481c0-.49.399-.889.89-.889zm68.747-5.927c.491 0 .89.397.89.889l-.001 1.481h1.482c.49 0 .889.397.889.89 0 .49-.398.888-.89.888h-1.481v1.482c0 .49-.398.889-.889.889-.49 0-.889-.399-.889-.89v-1.481h-1.481c-.49 0-.889-.398-.889-.889 0-.492.398-.889.889-.889h1.481v-1.481c0-.492.399-.889.89-.889zM75.4 28.107H13.177v3.852c0 .815.665 1.48 1.481 1.48h59.26c.816 0 1.481-.665 1.481-1.48v-3.852zM44.288 6.91L9.756 26.329H78.82L44.288 6.909zM19.393 9.44c.49 0 .889.4.889.889l-.001 1.481h1.482c.49 0 .889.4.889.89 0 .491-.398.888-.89.888h-1.481v1.482c0 .492-.398.889-.888.889-.491 0-.89-.398-.89-.89V13.59h-1.48c-.491 0-.89-.397-.89-.889 0-.49.399-.889.89-.889h1.48V10.33c0-.49.399-.889.89-.889zM62.063 5c.491 0 .89.397.89.889l-.001 1.481h1.482c.49 0 .89.397.89.89 0 .49-.4.888-.89.888h-1.482v1.482c0 .49-.398.888-.888.888s-.889-.398-.889-.888l-.001-1.482h-1.48c-.491 0-.89-.398-.89-.889 0-.492.399-.889.89-.889h1.48l.001-1.481c0-.492.398-.889.889-.889z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M59.04 21.292H29.536l14.752-8.296 14.752 8.296z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#146EB4",
    d: "M59.04 21.292H47.315l-3.027-8.296 14.752 8.296z",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#146EB4",
    d: "M32.93 20.404h22.716l-11.359-6.39-11.357 6.39zm26.11 1.777H29.534c-.404 0-.757-.272-.859-.666-.103-.39.071-.799.424-.998l14.752-8.296c.27-.153.601-.153.871 0l14.752 8.296c.352.2.527.608.425.998-.103.394-.457.666-.86.666z",
    opacity: 0.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankBg);
export default __webpack_public_path__ + "static/media/bank-bg.a40d9ee824c867c05d95851c40509f05.svg";
export { ForwardRef as ReactComponent };